<template>
  <div class="flex flex-wrap -mx-10">
    <div class="hidden lg:block lg:w-1/3 px-10">
      <profile-card :content="content" />
    </div>

    <div class="w-full lg:w-2/3 px-10">
      <div class="flex flex-wrap items-center justify-between pb-5">
        <div class="flex-grow">
          <div>
            <ol class="list-reset flex">
              <li><a :href="`/area/${content.subjectAreaId}`" class="font-bold">{{ content.subjectAreaName }}</a></li>
            </ol>
          </div>
          <h1 class="mb-0 mt-0">
            {{ content.name }}
          </h1>
        </div>
        <div v-if="!hasPurchased" class="shadow-lg bg-white rounded-full px-6 py-2 flex-shrink font-bold text-green text-2xl">
          ${{ cost }}
        </div>
      </div>

      <profile-card :content="content" full-width class="hidden md:block lg:hidden" />

      <div class="md:pt-16 lg:pt-0">
        <h3 class="mb-0">
          Lesson Description
        </h3>
      </div>
      <div class="rich-text" v-html="content.description" />

      <div v-if="hasPurchased">
        <h3 class="mb-0 mt-10">
          Lesson Materials
        </h3>
        <div class="pt-3">
          <content-tree-node v-for="item in contentItems" :key="item.id" :item="item" />
        </div>
      </div>
      <div v-else class="relative">
        <h3 class="mb-0 mt-10">
          Lesson Materials
        </h3>
        <div class="pt-3">
          <content-tree-node v-for="item in contentItems" :key="item.id" :item="item" />
        </div>
        <div class="absolute inset-0 bg-gray-200 opacity-90" />
        <div class="absolute w-full text-center px-20 pb-16 top-0">
          <d-icon icon="lock" class="text-6xl mb-5" />
          <p class="font-bold text-3xl mb-5">
            Would you like to purchase the lesson "{{ content.name }}" for ${{ cost }}?
          </p>
          <d-btn color="secondary-500" @click="launchBuyNowModal()">
            Buy Now
          </d-btn>
        </div>
      </div>
      <profile-card :content="content" class="md:hidden pt-5 pb-10" />
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import PaymentModal from '@resources/scripts/components/PaymentModal.vue';
  import ContentTreeNode from './components/ContentTreeNode.vue';
  import ProfileCard from './components/ProfileCard.vue';

  export default {
    parent: true,
    components: {
      ContentTreeNode,
      ProfileCard,
    },

    provide() {
      return {
        contentListing: this.content,
        hasPurchased: this.hasPurchased,
      };
    },

    props: {
      content: {
        type: Object,
        default: () => ({}),
      },
      hasPurchased: Boolean,
    },

    data() {
      return {
        loading: true,
        contentItems: [],
      };
    },

    computed: {
      cost() {
        if (Number.isNaN(this.content.cost) || this.content.cost === 0) {
          return null;
        }
        return this.content.cost.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2 });
      },
    },

    mounted() {
      this.getContentItems();
    },

    methods: {
      async getContentItems() {
        const { data } = await axios.get(`/api/content-listings/${this.content.id}/items`);
        this.contentItems = data;
      },

      launchBuyNowModal() {
        this.$modal.open({
          parent: this,
          component: PaymentModal,
          width: 550,
          hasModalCard: true,
          props: {
            selectedContent: this.content,
          },
        });
      },
    },
  };
</script>